import { ArrowUpRight } from "lucide-react";
import React, { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { COOActiveStepStore } from "src/store/coo-active-step.store";
import AddPurchaseModal from "../InventoryOverview/modals/PurchaseModals/AddPurchaseModal";
import EditPurchaseModal from "../InventoryOverview/modals/PurchaseModals/EditPurchaseModal";
import { UploadCSVModal } from "../InventoryOverview/modals/UploadCSVModal";
import styles from "./styles.module.scss";
import { steps } from "./utils";
import AddShipmentModal from "../InventoryOverview/modals/ShipmentModals/AddShipmentModal";
import EditShipmentModal from "../InventoryOverview/modals/ShipmentModals/EditShipmentModal";
import { SupplierModal } from "../InventoryOverview/modals/SupplierModal";
import { WarehouseModal } from "../InventoryOverview/modals/WarehouseModal";
import {
  EMPTY_PURCHASE,
  EMPTY_SHIPMENT,
} from "../InventoryOverview/forms/utils";
import CooLearningMaterials from "@components/CooLearningMaterials";

interface CooFlowProgressLineProps {}

const CooFlowProgressLine: React.FC<CooFlowProgressLineProps> = () => {
  const { step: activeStep, setStep: setActiveStep } = COOActiveStepStore();
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);
  const nextStep = () => {
    closeModal();
    setActiveStep(activeStep + 1);
  };

  const ModalContent = (() => {
    if (!modalOpen) return null;
    switch (activeStep) {
      case 1:
        return <SupplierModal open onClose={closeModal} onSubmit={nextStep} />;
      case 2:
        return <WarehouseModal open onClose={closeModal} onSubmit={nextStep} />;
      case 3:
        return (
          <UploadCSVModal
            title="Upload Purchase Orders"
            open
            ManualModal={AddPurchaseModal}
            EditModal={EditPurchaseModal}
            data={[EMPTY_PURCHASE]}
            onSaveData={nextStep}
            onCancel={closeModal}
          />
        );
      case 4:
        return (
          <UploadCSVModal
            title="Upload Shipment Orders"
            open
            ManualModal={AddShipmentModal}
            EditModal={EditShipmentModal}
            data={[EMPTY_SHIPMENT]}
            onSaveData={nextStep}
            onCancel={closeModal}
          />
        );
      default:
        return null;
    }
  })();

  if (activeStep > 4) return null;

  return (
    <div className={styles.container}>
      <div className={styles.timeline}>
        {steps.map((step) => {
          const stepNum = Number(step.id);
          const isActive = stepNum === activeStep;
          const isDone = stepNum < activeStep;

          return (
            <div key={step.id} className={styles.step}>
              <div
                className={`${styles.circle} ${isActive ? styles.active : ""} ${
                  isDone ? styles.completed : ""
                }`}
              >
                {stepNum}
              </div>
              <div className={styles.label}>
                <span
                  className={`${isActive ? styles.textActive : ""} ${
                    isDone ? styles.textCompleted : ""
                  }`}
                >
                  {step.title}
                </span>
                {step.link && isActive && (
                  <button onClick={openModal} className={styles.linkButton}>
                    <ArrowUpRight
                      size={16}
                      color="#5295E0"
                      className={styles.icon}
                    />
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {ModalContent}

      {[1, 2, 3, 4].includes(activeStep) && (
        <CooLearningMaterials setModal={setModalOpen} activeStep={activeStep} />
      )}
    </div>
  );
};

export default CooFlowProgressLine;
